import { parsePtNumber } from './money';

/**
 * Meses até ao mês da despesa (alinhado com create_pot_for_occasional / monthly_required).
 */
export function monthsUntilOccasionalMonth(
  expenseMonth,
  referenceDate = new Date(),
  targetYear = null,
) {
  const month = Number(expenseMonth);
  if (!Number.isFinite(month) || month < 1 || month > 12) return 1;

  const today = new Date(referenceDate);
  const todayYear = today.getFullYear();
  const todayMonth = today.getMonth() + 1;
  const todayDay = today.getDate();

  let referenceYear = targetYear ?? todayYear;
  if (targetYear == null) {
    if (month < todayMonth) {
      referenceYear = todayYear + 1;
    }
  }

  const lastDay = new Date(referenceYear, month, 0).getDate();
  let months = (referenceYear - todayYear) * 12 + (month - todayMonth);
  if (lastDay >= todayDay) {
    months += 1;
  }
  return Math.max(months, 1);
}

/**
 * Estimativa mensal para o cofre de suavização.
 * @returns {{ monthly: number, months: number } | null}
 */
export function estimateOccasionalMonthlySavings(
  amount,
  expenseMonth,
  referenceDate = new Date(),
  targetYear = null,
) {
  const total =
    typeof amount === 'number' ? amount : parsePtNumber(String(amount ?? ''));
  if (!total || total <= 0) return null;

  const months = monthsUntilOccasionalMonth(expenseMonth, referenceDate, targetYear);
  const monthly = Math.round((total / months) * 100) / 100;
  return { monthly, months };
}
